import { Edit } from '../../../../shared/assets/AppIcons';
import {
  CreateFormDialog,
  CreateFormCancelButton,
  CreateFormSubmitButton,
} from '../../../../shared/components/CreateFormDialog';
import { FormFooterAction } from '../../../../shared/components/FormActionsContext';
import React from 'react';
import { CheckCircle2, Mail } from '../../../../shared/assets/AppIcons';

import { Textarea } from '@/shared/ui/textarea';

export default function EditAutomationDialog({
  open,
  onOpenChange,
  automation,
  value,
  onChange,
  onSubmit,
  submitted,
}) {
  return (
    <CreateFormDialog open={open} onOpenChange={onOpenChange} icon={Edit} title="Richiesta Modifica">
      {!submitted ? (
        <div className="mt-4 space-y-4">
          <div>
            <p className="text-sm text-[var(--text-secondary)] mb-3">
              Descrivi le modifiche che desideri apportare all'automazione{' '}
              <strong>"{automation?.nome}"</strong>.
            </p>
            <Textarea
              placeholder="Es: Vorrei aggiungere un campo per il codice fiscale..."
              value={value}
              onChange={(event) => onChange(event.target.value)}
              className="min-h-32 resize-none"
            />
          </div>

          <div className="bg-[var(--primary-soft)] border border-[var(--border-strong)] rounded-lg p-3">
            <div className="flex items-start gap-2">
              <Mail className="text-[var(--primary)] mt-0.5" size={16} />
              <div>
                <p className="text-sm font-medium text-[var(--primary)]">Simulazione locale</p>
                <p className="text-xs text-[var(--primary)]">
                  Questa richiesta resta nella demo locale e non viene inviata a un workflow backend reale.
                </p>
              </div>
            </div>
          </div>

          <FormFooterAction>
            <div className="form-footer-actions">
              <CreateFormCancelButton onClick={() => onOpenChange(false)} type="button">
                Annulla
              </CreateFormCancelButton>
              <CreateFormSubmitButton onClick={onSubmit} disabled={!value.trim()} type="button">
                Invia Richiesta
              </CreateFormSubmitButton>
            </div>
          </FormFooterAction>
        </div>
      ) : (
        <div className="mt-4 py-8 text-center">
          <div className="w-16 h-16 bg-[var(--success-soft)] rounded-full flex items-center justify-center mx-auto mb-4">
            <CheckCircle2 className="text-[var(--success-text)]" size={32} />
          </div>
          <h3 className="text-lg font-semibold text-[var(--text-primary)] mb-2">Richiesta Inviata!</h3>
          <p className="text-sm text-[var(--text-secondary)]">
            La richiesta e stata registrata solo nella demo locale del modulo.
          </p>
        </div>
      )}
    </CreateFormDialog>
  );
}
